<template lang="pug">
v-app
  v-content
    router-view
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
@import './plugins/meltline.css';
@import "@/scss/_variables.scss";
@import url(http://fonts.googleapis.com/earlyaccess/notosansjapanese.css); /* 源ノ角ゴシック */
html, body {
  margin: 0;
  font-family: 'Noto Sans Japanese', Arial, Verdana, Roboto, "游ゴシック", "Yu Gothic", "游ゴシック体", "YuGothic", "ヒラギノ角ゴ Pro W3", "Hiragino Kaku Gothic Pro", "Meiryo UI", "メイリオ", Meiryo, "ＭＳ Ｐゴシック", "MS PGothic", sans-serif;
}

a {
  color: $active_color !important;
}
</style>
